import { isPlatformBrowser } from '@angular/common';
import { Component, inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { map, Observable, of, shareReplay } from 'rxjs';
import { GetDocumentService } from 'src/app/customServices/get-document.service';
import { LanguageService } from '@spartacus/core';

@Component({
  selector: 'app-coreShippingTab',
  templateUrl: './KbcoreShippingTab.component.html',
  styleUrls: ['./KbcoreShippingTab.component.scss'],
  standalone: false
})
export class KbCoreShippingTabComponent {
  @Input() shipping: any;
  platformId = inject(PLATFORM_ID);
  activeLanguage$!: Observable<string>;

  documentUrlsMap: { [key: string]: string } = {};
  constructor(private documentService: GetDocumentService, private languageService: LanguageService) { }
  ngOnInit() {
    this.setCustomWidth();
    this.shipping?.forEach((doc: any) => {
      if (doc?.code) {
        this.loadDocument(doc.code);
      }
    });
  }


  loadDocument(code: string): void {
    this.documentService
      .getDocumentByDocumentCode(code)
      .pipe(
        map((res: any) => res?.url ?? '')
      )
      .subscribe((url: string) => {
        this.documentUrlsMap[code] = url;
      });
  }



  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth;
      document.documentElement.style.setProperty('--custom-naShippingCoreTab-width', `${widthInPixels}px`);
    }
  }
}
